// extracted by mini-css-extract-plugin
export default {"main":"events_main__BXblc","container":"events_container__wUSaO","header":"events_header__YjKTe","filters":"events_filters__wyQk9","tabs":"events_tabs__eYsFz"};